import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = ({ setUser }) => { 
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:5000/api/users/login', { correo, password });
      alert(response.data.message || 'Inicio de sesión exitoso');
      setUser({ username: response.data.username }); 
      navigate('/');
    } catch (error) {
      console.error('Error al procesar el inicio de sesión:', error.response ? error.response.data : error.message);
      alert(error.response?.data?.message || 'Error al iniciar sesión, intente de nuevo');
    }
  };

  return (
    <div 
      style={{ 
        padding: '20px', 
        backgroundColor: '#FFFFFF',
        fontFamily: "'Lato', sans-serif", 
        maxWidth: '400px', 
        margin: '0 auto', 
        borderRadius: '10px', 
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' 
      }}
    >
      <h1 style={{ 
        color: '#556B2F', 
        textAlign: 'center', 
        marginBottom: '20px' 
      }}>
        Iniciar Sesión
      </h1>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ 
            display: 'block', 
            color: '#2F4F4F', 
            fontWeight: 'bold', 
            marginBottom: '5px' 
          }}>
            Correo electrónico:
          </label>
          <input 
            type="email" 
            value={correo} 
            onChange={(e) => setCorreo(e.target.value)} 
            required 
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #556B2F', 
              borderRadius: '5px' 
            }} 
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ 
            display: 'block', 
            color: '#2F4F4F', 
            fontWeight: 'bold', 
            marginBottom: '5px' 
          }}>
            Contraseña:
          </label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
            style={{ 
              width: '100%', 
              padding: '10px', 
              border: '1px solid #556B2F',
              borderRadius: '5px' 
            }} 
          />
        </div>
        <button 
          type="submit" 
          style={{ 
            width: '100%', 
            padding: '10px 0', 
            backgroundColor: '#2F4F4F', 
            color: '#FFFFFF', 
            border: 'none', 
            borderRadius: '5px', 
            cursor: 'pointer', 
            fontWeight: 'bold' 
          }}
        >
          Iniciar Sesión
        </button>
      </form>
    </div>
  );
};

export default Login;